/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useProductDetails } from '@/features/product/api/getProductDetails';
import { useMyProfile } from '@/features/myProfile/api/getMyProfileV2';
import { useLabels } from '@/hooks/useLabels';
import type { ReviewStatistic } from '../../../interface/types';

const labelMap = {
  writeAReview: 'label_reviews_writeAReviewCTA',
  reviews: 'label_reviews',
  recommendations: 'label_reviews_recommendations',
  recommendThis: 'label_reviews_recommendThisProduct',
  recommended: 'label_reviews_recommended',
  singleReview: 'label_single_review',
  singleRecommendation: 'label_single_recommendation',
};

type UseReviewsOverviewPropsParams = {
  reviewStatistic: ReviewStatistic | undefined;
  reviewCount: string;
  recommendedCount: number;
};

export const useReviewsOverviewProps = ({
  reviewStatistic,
  reviewCount,
  recommendedCount,
}: UseReviewsOverviewPropsParams) => {
  const { data: productDetails } = useProductDetails({ enabled: false });
  const { data: myProfile } = useMyProfile();
  const labels = useLabels(labelMap);

  return {
    reviewStatistic,
    reviewCount,
    recommendedCount,
    productId: productDetails?.product?.itemId,
    productName: productDetails?.product?.itemDescription,
    productImageUrl: productDetails?.product?.itemImageUrl,
    myProfileEmail: myProfile?.email,
    myProfileFirstName: myProfile?.firstName,
    labels,
  };
};
